export const regex = (regex, flag = 'gi') => value => {
  const rge = new RegExp(regex, flag)
  return rge.test(value)
}
export const dateObject = value => {
  return !value || value instanceof Date
}
